import classnames from 'classnames/bind'
import React from 'react'

import BoxDocument, { BoxDocumentProps } from '~/components/BoxDocument'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface LineDocumentsProps {
  className?: string
  items?: BoxDocumentProps[]
}

function LineDocuments({ className, items }: LineDocumentsProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })

  return (
    <div className={cx(css.LineDocuments, className)}>
      <div className={gridStyle}>
        {items?.map((item, index) => (
          <BoxDocument key={index} className={css.box} {...item} />
        ))}
      </div>
    </div>
  )
}

LineDocuments.defaultProps = {}

export default LineDocuments
